import { Box, Button, Card, Container, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import Logo from "@/assets/logos/bitelink-logo-blue-bg.svg";

interface AuthLayoutProps {
  children?: React.ReactNode;
  icon: ReactNode;
  title: string;
  subtitle?: ReactNode;
  primaryAction: {
    label: string;
    onClick: () => void;
    loading?: boolean;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
    btnIcon?: ReactNode;
  };
}

const AuthLayout = ({ children, icon, title, subtitle, primaryAction, secondaryAction }: AuthLayoutProps) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#0A63F3",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="xs">
        <Stack justifyContent={"center"} alignItems="center" spacing={3}>
          <img src={Logo} alt="Bitelink logo" />

          <Card
            sx={{
              borderRadius: 3,
              p: 4,
              textAlign: "center",
            }}
          >
            <Box
              sx={{
                width: 100,
                height: 100,
                borderRadius: "50%",
                backgroundColor: "#EAF1FF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
                mb: 2,
              }}
            >
              {icon}
            </Box>
            <Stack spacing={2}>
              {title ? <Typography variant="h3">{title}</Typography> : null}

              {subtitle ? (
                <Typography variant="body2" color="text.secondary">
                  {subtitle}
                </Typography>
              ) : null}
              {children && <Box mb={3}>{children}</Box>}
              <Button fullWidth variant="contained" size="large" onClick={primaryAction.onClick} disabled={primaryAction.loading}>
                {primaryAction.label}
              </Button>
            </Stack>
          </Card>

          {secondaryAction && (
            <Stack>
              <Button variant="outlined" sx={{ color: "#fff", borderColor: "#ffffff25" }} onClick={secondaryAction.onClick} startIcon={secondaryAction.btnIcon}>
                {secondaryAction.label}
              </Button>
            </Stack>
          )}
        </Stack>
      </Container>
    </Box>
  );
};

export default AuthLayout;
